import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Repo from "../../Repository/Repo";

const initialState = {
  outOfStockItems: [],
  next_page_token: "",
  totalSales: "",
  totalItems: "",
  soldItems: "",
  totalStockValue: "",
  totalStockSaleValue:"",
  loading: false,
  error: "",
};

export const getDashboardData = createAsyncThunk("data/fetchData", () => {
  return Repo.default({
    request: {
      method: "getDashboardData",
      data: {
        company_code: localStorage.getItem("companyCode"),
        next_page_token: initialState.next_page_token,
      },
    },
  })
    .then(({ data }) => data.response.data)
    .catch((err) => console.log(err));
});

export const dashboardSlice = createSlice({
  name: "dashboardData",
  initialState,

  extraReducers: (builder) => {
    builder.addCase(getDashboardData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDashboardData.fulfilled, (state, action) => {
      state.loading = false;
      const {
        outOfStockItems,
        next_page_token,
        totalSales,
        count,
        soldItems,
        totalStockValue,
        totalStockSaleValue,
      } = action.payload;
      state.outOfStockItems = outOfStockItems;
      state.next_page_token = next_page_token;
      state.totalSales = totalSales;
      state.totalItems = count;
      state.soldItems = soldItems;
      state.totalStockValue = totalStockValue;
      state.totalStockSaleValue = totalStockSaleValue;
      state.error = "";
    });
    builder.addCase(getDashboardData.rejected, (state, action) => {
      state.loading = false;
      state.outOfStockItems = [];
      state.next_page_token = "";
      state.totalSales = "";
      state.totalItems = "";
      state.soldItems = "";
      state.totalStockValue = "";
      state.error = action.error.message;
    });
  },
});

export default dashboardSlice.reducer;
